import styled from "@emotion/styled";
import {
  Box,
  IconButton,
  ListItem,
  ListItemButton,
  Typography,
} from "@mui/material";
import { HEADER_AND_TAB_HEIGHT } from "../../ChatInfo.style";
import theme from "../../../theme";

export const MembersWrapper = styled(Box)`
  max-height: calc(100dvh - ${HEADER_AND_TAB_HEIGHT}px);
  overflow: auto;
`;

export const GroupMembersHeader = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 24px;
`;

export const CurrentUserAbout = styled(Typography)`
  width: 250px;
  font-size: small;
`;

export const MemberListItem = styled(ListItem)`
  min-height: 65px;
  padding-right: 4px;

  &:hover {
    background: ${theme.palette.background.paper};
  }

  & > .MuiListItemSecondaryAction-root {
    right: 8px;
  }
`;

export const MemberListItemButton = styled(ListItemButton)`
  padding: 12px 12px 12px 0;

  &:hover {
    background: transparent;
  }
`;

export const RemoveMemberButton = styled(IconButton)``;

export const RevokeReferralButton = styled(IconButton)``;
